import React from 'react'
import { Button, Collapse } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import { KeywordGroupWithMembers } from './keywords/keywords-interfaces'
import { isGroupFullySelected, toggleGroupKeywords } from './keywords/keywords-service'

interface KeywordGroupsToolbarProps {
  groups: KeywordGroupWithMembers[]
  selectedKeywords: string[]
  onSelectedKeywordsChange: (keywords: string[]) => void
}

export default function KeywordGroupsToolbar(props: KeywordGroupsToolbarProps) {
  if (props.groups.length === 0) {
    return null
  }

  return (
    <Collapse
      defaultActiveKey={['keyword-groups']}
      ghost
      size="small"
      style={{ borderBottom: '1px solid #f0f0f0' }}
      items={[
        {
          key: 'keyword-groups',
          label: 'Sélection par groupes de mots clés',
          children: (
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', paddingBottom: '4px' }}>
              {props.groups.map(group => {
                const fullySelected = isGroupFullySelected(group.keywords, props.selectedKeywords)

                return (
                  <Button
                    key={group.id}
                    size="small"
                    type={fullySelected ? 'primary' : 'default'}
                    icon={fullySelected ? <CheckOutlined /> : undefined}
                    onClick={() => {
                      props.onSelectedKeywordsChange(
                        toggleGroupKeywords(props.selectedKeywords, group.keywords)
                      )
                    }}
                  >
                    {group.name} ({group.keywords.length})
                  </Button>
                )
              })}
            </div>
          )
        }
      ]}
    />
  )
}
